import { render, staticRenderFns } from "./ResourcePoolMenu.vue?vue&type=template&id=b361c4ac&"
import script from "./ResourcePoolMenu.vue?vue&type=script&lang=js&"
export * from "./ResourcePoolMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports